<section
  *ngrxLet="
    {
      company: company$,
      currentTheme: currentTheme$,
      currentPerson: currentPerson$,
      currentUser: currentUser$,
      disableNavLinks: disableNavLinks$,
      hasPartnerHubAccess: hasPartnerHubAccess$,
      isExpanded: isExpanded$,
      isHidden: isHidden$,
      language: language$,
      profileMenuIcon: profileMenuIcon$,
      userAvatarInfo: userAvatarInfo$,
      enableSurveys: enableSurveys$,
      enableSurveysPill: enableSurveysPill$,
      enableReferrals: enableReferralProgram$,
      showInbox: showInbox$,
      isTrialSubscription: isTrialSubscription$,
      url: url$,
      companyCreatedAfterPricingGoLive: companyCreatedAfterPricingGoLive$,
      redirectToKstGoLiveDate: redirectToKstGoLiveDate$,
    } | ngrxPush as context
  "
  (click)="preventEventProp($event)"
  id="main-sidebar"
  #container
  [class.is-open]="context.isExpanded"
  [class.is-closed]="!context.isExpanded"
  [class.hide-instead-of-ngIf]="context.isHidden"
  [class.dual-theme]="context.currentTheme === Theme.DUAL"
  [@openCloseSidenav]="context.isExpanded ? 'open' : 'closed'">
  <button
    type="button"
    data-product="main-sidebar__expand-collapse-button"
    class="toggle-button-wrapper"
    [ngClass]="{
      'toggle-nav-expanded': context.isExpanded,
      'toggle-nav-closed': !context.isExpanded,
      'toggle-button-wrapper--mobile': isMobile,
    }"
    [attr.aria-label]="context.isExpanded ? 'Collapse navigation' : 'Expand navigation'"
    (click)="toggleSideNav()"
    [ninetyTooltip]="context.isExpanded ? 'Collapse' : 'Expand'"
    [tpIsEnabled]="!isTablet"
    tpPlacement="right">
    <div class="toggle-nav-button">
      @if (context.isExpanded) {
        <terra-icon data-cy="main-sidebar_toggle-icon" icon="caret-left" variant="bold" size="12" />
      }
      @if (!context.isExpanded) {
        <terra-icon data-cy="main-sidebar_toggle-icon" icon="caret-right" variant="bold" size="12" />
      }
    </div>
  </button>

  <div
    class="company-menu"
    [class]="{
      'dual-theme': context.currentTheme === Theme.DUAL,
    }">
    <ninety-company-menu [isSidenavExpanded]="context.isExpanded" [theme]="context.currentTheme"></ninety-company-menu>
  </div>

  <div
    id="nav-tools"
    #navTools
    class="nav-tools-menu nav-tools-scroll-shadow"
    [class.dual-theme]="context.currentTheme === Theme.DUAL">
    <!-- ============================ Main Navigation ============================== -->
    @if (context.currentPerson) {
      <mat-nav-list [ngClass]="context.isExpanded ? '' : 'nav-list-closed'">
        @if (context.hasPartnerHubAccess) {
          <ninety-navigation-menu-item
            iconKey="partner-hub"
            data-cy="main-sidebar_partner-hub"
            title="Partner Hub"
            [isExpanded]="context.isExpanded"
            [showTooltip]="!isTablet"
            [theme]="context.currentTheme"
            tabindex="-1"
            [routerLink]="[{ outlets: { detail: null, primary: 'partner-hub' } }]">
          </ninety-navigation-menu-item>
          <hr />
        }

        <ninety-navigation-menu-item
          iconKey="my-90"
          data-cy="main-sidebar_my90"
          [title]="context.language.my90.route"
          [isExpanded]="context.isExpanded"
          [showTooltip]="!isTablet"
          [theme]="context.currentTheme"
          [disabled]="context.disableNavLinks"
          [featureAvailable]="NinetyFeatures.my90 | isFeatureAvailable | ngrxPush"
          [tieredPageActive]="context.url | isTieredPageActive: NinetyFeatures.my90"
          tabindex="-1"
          [routerLink]="context.disableNavLinks ? null : [{ outlets: { detail: null, primary: 'home' } }]">
        </ninety-navigation-menu-item>

        @if (context.showInbox) {
          <ninety-navigation-menu-item
            iconKey="envelope"
            data-cy="main-sidebar_inbox"
            title="Inbox"
            [isExpanded]="context.isExpanded"
            [showTooltip]="!isTablet"
            [theme]="context.currentTheme"
            [disabled]="context.disableNavLinks"
            tabindex="-1"
            [routerLink]="context.disableNavLinks ? null : [{ outlets: { detail: null, primary: 'inbox' } }]"
            [state]="inboxEntryPointState">
          </ninety-navigation-menu-item>
        }

        <div class="beta-menu-item">
          <ninety-navigation-menu-item
            iconKey="lightbulb"
            data-cy="main-sidebar_insights"
            title="Insights"
            [isExpanded]="context.isExpanded"
            [showTooltip]="!isTablet"
            [theme]="context.currentTheme"
            [disabled]="context.disableNavLinks"
            [featureAvailable]="NinetyFeatures.insights | isFeatureAvailable | ngrxPush"
            [tieredPageActive]="context.url | isTieredPageActive: NinetyFeatures.insights"
            tabindex="-1"
            [routerLink]="context.disableNavLinks ? null : [{ outlets: { detail: null, primary: 'insights' } }]">
          </ninety-navigation-menu-item>
        </div>

        <hr />

        <!-- Scorecard Route -->
        <div class="beta-menu-item">
          <ninety-navigation-menu-item
            iconKey="data"
            data-cy="main-sidebar_data"
            [attr.data-product]="'main-sidenav__scorecard-beta-link'"
            [title]="context.language.scorecard.route"
            [isExpanded]="context.isExpanded"
            [showTooltip]="!isTablet"
            [theme]="context.currentTheme"
            [disabled]="context.disableNavLinks"
            [featureAvailable]="NinetyFeatures.scorecard | isFeatureAvailable | ngrxPush"
            [tieredPageActive]="context.url | isTieredPageActive: NinetyFeatures.scorecard"
            tabindex="-1"
            [routerLink]="
              context.disableNavLinks ? null : [{ outlets: { detail: null, primary: 'data/scorecards/weekly' } }]
            ">
          </ninety-navigation-menu-item>
        </div>

        <ninety-navigation-menu-item
          iconKey="rocks"
          data-cy="main-sidebar_rocks-v3"
          [title]="context.language.rock.route"
          [isExpanded]="context.isExpanded"
          [showTooltip]="!isTablet"
          [theme]="context.currentTheme"
          [disabled]="context.disableNavLinks"
          [featureAvailable]="NinetyFeatures.rocks | isFeatureAvailable | ngrxPush"
          [tieredPageActive]="context.url | isTieredPageActive: NinetyFeatures.rocks"
          tabindex="-1"
          [routerLink]="context.disableNavLinks ? null : [{ outlets: { detail: null, primary: 'rocks' } }]">
        </ninety-navigation-menu-item>

        <ninety-navigation-menu-item
          iconKey="to-dos"
          data-cy="main-sidebar_todos"
          [title]="context.language.todo.route"
          [isExpanded]="context.isExpanded"
          [showTooltip]="!isTablet"
          [theme]="context.currentTheme"
          [disabled]="context.disableNavLinks"
          [featureAvailable]="NinetyFeatures.todos | isFeatureAvailable | ngrxPush"
          [tieredPageActive]="context.url | isTieredPageActive: NinetyFeatures.todos"
          tabindex="-1"
          [routerLink]="context.disableNavLinks ? null : [{ outlets: { detail: null, primary: 'todos' } }]">
        </ninety-navigation-menu-item>

        <ninety-navigation-menu-item
          iconKey="issues"
          data-cy="main-sidebar_issues"
          [title]="context.language.issue.route"
          [isExpanded]="context.isExpanded"
          [showTooltip]="!isTablet"
          [theme]="context.currentTheme"
          [disabled]="context.disableNavLinks"
          [featureAvailable]="NinetyFeatures.issues | isFeatureAvailable | ngrxPush"
          [tieredPageActive]="context.url | isTieredPageActive: NinetyFeatures.issues"
          tabindex="-1"
          [routerLink]="context.disableNavLinks ? null : [{ outlets: { detail: null, primary: 'issues' } }]">
        </ninety-navigation-menu-item>

        <ninety-navigation-menu-item
          iconKey="meetings"
          data-cy="main-sidebar_meetings"
          [title]="context.language.meeting.route"
          [isExpanded]="context.isExpanded"
          [showTooltip]="!isTablet"
          [theme]="context.currentTheme"
          [disabled]="context.disableNavLinks"
          [featureAvailable]="NinetyFeatures.weeklyMeetings | isFeatureAvailable | ngrxPush"
          [tieredPageActive]="context.url | isTieredPageActive: NinetyFeatures.weeklyMeetings"
          tabindex="-1"
          [routerLink]="context.disableNavLinks ? null : [{ outlets: { detail: null, primary: 'meetings' } }]">
        </ninety-navigation-menu-item>

        <ninety-navigation-menu-item
          iconKey="headlines"
          data-cy="main-sidebar_headlines"
          [title]="context.language.headline.items"
          [isExpanded]="context.isExpanded"
          [showTooltip]="!isTablet"
          [theme]="context.currentTheme"
          [disabled]="context.disableNavLinks"
          [featureAvailable]="NinetyFeatures.headlines | isFeatureAvailable | ngrxPush"
          [tieredPageActive]="context.url | isTieredPageActive: NinetyFeatures.headlines"
          tabindex="-1"
          [routerLink]="context.disableNavLinks ? null : [{ outlets: { detail: null, primary: 'headlines' } }]">
        </ninety-navigation-menu-item>

        <hr />

        <ninety-navigation-menu-item
          iconKey="vision"
          data-cy="main-sidebar_vision"
          [title]="context.language.vto.route"
          [isExpanded]="context.isExpanded"
          [showTooltip]="!isTablet"
          [theme]="context.currentTheme"
          [disabled]="context.disableNavLinks"
          [featureAvailable]="NinetyFeatures.vision | isFeatureAvailable | ngrxPush"
          [tieredPageActive]="context.url | isTieredPageActive: NinetyFeatures.vision"
          tabindex="-1"
          [routerLink]="context.disableNavLinks ? null : [{ outlets: { detail: null, primary: 'vision' } }]">
        </ninety-navigation-menu-item>

        @if (canAccessOrgChart$ | ngrxPush) {
          <ninety-navigation-menu-item
            iconKey="responsibilities"
            data-cy="main-sidebar_responsibilities"
            data-product="main-sidebar__responsibilities-button"
            [title]="context.language.acChart.route"
            [isExpanded]="context.isExpanded"
            [showTooltip]="!isTablet"
            [theme]="context.currentTheme"
            [disabled]="context.disableNavLinks"
            [featureAvailable]="NinetyFeatures.orgChart | isFeatureAvailable | ngrxPush"
            [tieredPageActive]="context.url | isTieredPageActive: NinetyFeatures.orgChart"
            tabindex="-1"
            [routerLink]="context.disableNavLinks ? null : [{ outlets: { detail: null, primary: 'chart' } }]">
          </ninety-navigation-menu-item>
        }

        @if (context.currentUser?.isManageeOrAbove) {
          <ng-container *ngrxLet="peopleAnalyzerPill$ as paPill">
            @if ((paPill || '').trim()) {
              <div class="beta-menu-item">
                <ninety-navigation-menu-item
                  iconKey="one-on-one"
                  data-cy="main-sidebar_1-on-1"
                  [title]="context.language.feedback.route"
                  [isExpanded]="context.isExpanded"
                  [showTooltip]="!isTablet"
                  [theme]="context.currentTheme"
                  [disabled]="context.disableNavLinks"
                  [featureAvailable]="NinetyFeatures.oneOnOne | isFeatureAvailable | ngrxPush"
                  [tieredPageActive]="context.url | isTieredPageActive: NinetyFeatures.oneOnOne"
                  tabindex="-1"
                  [routerLink]="context.disableNavLinks ? null : [{ outlets: { detail: null, primary: '1-on-1' } }]">
                </ninety-navigation-menu-item>
                <ninety-chip class="beta-chip" color="brand">{{ paPill }}</ninety-chip>
              </div>
            } @else {
              <ninety-navigation-menu-item
                iconKey="one-on-one"
                data-cy="main-sidebar_1-on-1"
                [title]="context.language.feedback.route"
                [isExpanded]="context.isExpanded"
                [showTooltip]="!isTablet"
                [theme]="context.currentTheme"
                [disabled]="context.disableNavLinks"
                [featureAvailable]="NinetyFeatures.oneOnOne | isFeatureAvailable | ngrxPush"
                [tieredPageActive]="context.url | isTieredPageActive: NinetyFeatures.oneOnOne"
                tabindex="-1"
                [routerLink]="context.disableNavLinks ? null : [{ outlets: { detail: null, primary: '1-on-1' } }]">
              </ninety-navigation-menu-item>
            }
          </ng-container>
        }

        @if (!context.currentUser?.isLite) {
          <div class="beta-menu-item">
            <ninety-navigation-menu-item
              iconKey="student"
              data-cy="main-sidebar_learn"
              [title]="'Knowledge'"
              [isExpanded]="context.isExpanded"
              [showTooltip]="!isTablet"
              [theme]="context.currentTheme"
              [disabled]="context.disableNavLinks"
              [featureAvailable]="NinetyFeatures.kst | isFeatureAvailable | ngrxPush"
              [tieredPageActive]="context.url | isTieredPageActive: NinetyFeatures.kst"
              tabindex="-1"
              [routerLink]="context.disableNavLinks ? null : [{ outlets: { detail: null, primary: 'knowledge' } }]">
            </ninety-navigation-menu-item>
          </div>
        }

        <ninety-navigation-menu-item
          iconKey="directory"
          data-cy="main-sidebar_directory"
          [title]="context.language.directory.route"
          [isExpanded]="context.isExpanded"
          [showTooltip]="!isTablet"
          [theme]="context.currentTheme"
          [disabled]="context.disableNavLinks"
          [featureAvailable]="NinetyFeatures.directory | isFeatureAvailable | ngrxPush"
          [tieredPageActive]="context.url | isTieredPageActive: NinetyFeatures.directory"
          tabindex="-1"
          [routerLink]="context.disableNavLinks ? null : [{ outlets: { detail: null, primary: 'directory' } }]">
        </ninety-navigation-menu-item>

        @if (
          context.company?.settings?.mastery.enabled &&
          !context.currentUser?.isLite &&
          !context.companyCreatedAfterPricingGoLive
        ) {
          <ninety-navigation-menu-item
            iconKey="mastery"
            data-cy="main-sidebar_mastery"
            [title]="context.language.mastery.route"
            [isExpanded]="context.isExpanded"
            [showTooltip]="!isTablet"
            [theme]="context.currentTheme"
            [disabled]="context.disableNavLinks"
            tabindex="-1"
            [routerLink]="context.disableNavLinks ? null : [{ outlets: { detail: null, primary: 'mastery' } }]">
          </ninety-navigation-menu-item>
        }

        @if (context.enableSurveys) {
          <!-- Show Assessment tool with "New" pill -->
          @if (context.enableSurveysPill) {
            <div class="beta-menu-item">
              <ng-container *ngTemplateOutlet="assessmentTool" />
              <ninety-chip class="beta-chip" color="brand">New</ninety-chip>
            </div>
          } @else {
            <ng-container *ngTemplateOutlet="assessmentTool" />
          }

          <!-- Show Assessment tool without "New" pill -->

          <ng-template #assessmentTool>
            <ninety-navigation-menu-item
              iconKey="surveys"
              data-cy="main-sidebar_surveys"
              [title]="context.language.survey?.route"
              [isExpanded]="context.isExpanded"
              [showTooltip]="!isTablet"
              [theme]="context.currentTheme"
              [disabled]="context.disableNavLinks"
              [featureAvailable]="NinetyFeatures.assessments | isFeatureAvailable | ngrxPush"
              [tieredPageActive]="context.url | isTieredPageActive: NinetyFeatures.assessments"
              tabindex="-1"
              [routerLink]="context.disableNavLinks ? null : [{ outlets: { detail: null, primary: 'assessments' } }]">
            </ninety-navigation-menu-item>
          </ng-template>
        }
      </mat-nav-list>
    }
  </div>
  <div class="fill-remaining-space"></div>

  <!-- ============================ Bottom Buttons ============================== -->

  <div
    class="utils-section"
    [class]="{
      'dual-theme': context.currentTheme === Theme.DUAL,
    }">
    <ng-container *ngrxLet="showGettingStartedTracker$ as showGettingStartedTracker">
      @if (showGettingStartedTracker) {
        <div class="getting-started-container">
          <ninety-getting-started-tracker [isExpanded]="context.isExpanded" />
        </div>
      }

      @if (!showGettingStartedTracker && (shouldDisplayTrialCountdown$ | ngrxPush)) {
        <ninety-trial-countdown
          [theme]="context.currentTheme"
          [isSidenavExpanded]="context.isExpanded"
          [callToActionActive]="context.currentUser?.isAdminOrOwner"
          data-cy="main-sidebar_trial-countdown"></ninety-trial-countdown>
      }
    </ng-container>

    @if (context.userAvatarInfo; as avatar) {
      <mat-nav-list [ngClass]="context.isExpanded ? '' : 'nav-list-closed'">
        @if (context.currentUser.isManagerOrAbove && !context.disableNavLinks) {
          <ninety-navigation-menu-item
            (click)="openAddInviteDialog()"
            iconKey="user-add"
            data-cy="main-sidebar_invite-teammates-item"
            [title]="'Add Teammates'"
            [isExpanded]="context.isExpanded"
            [showTooltip]="!isTablet"
            [theme]="context.currentTheme"
            data-product="main-sidebar__invite-teammates-button">
          </ninety-navigation-menu-item>
        }
        <ninety-navigation-menu-item
          data-cy="main-sidebar_provide-feedback-item"
          data-product="main-sidebar__provide-feedback-button"
          iconKey="note-pencil"
          [title]="'Provide Feedback'"
          [isExpanded]="context.isExpanded"
          [showTooltip]="provideFeedbackTooltip.disabled"
          [theme]="context.currentTheme"
          (click)="provideFeedbackTooltip.disabled = false; provideFeedbackTooltip.show()"
          #provideFeedbackTooltip="matTooltip"
          matTooltip="Can't see the feedback form? Please check your ad blocker settings."
          matTooltipPosition="right"
          matTooltipClass="ninety-tooltip"
          matTooltipDisabled="true">
        </ninety-navigation-menu-item>

        <ninety-navigation-menu-item
          data-cy="main-sidebar_learning-and-support-item"
          data-product="main-sidebar__learn-support-menu-button"
          #learnAndSupportTrigger
          type="button"
          iconKey="question-circle"
          [title]="'Learning and Support'"
          [isExpanded]="context.isExpanded"
          [showTooltip]="!isTablet"
          [theme]="context.currentTheme"
          (click)="showLearnAndSupportMenu()">
        </ninety-navigation-menu-item>

        @if (context.enableReferrals && !context.currentUser?.isImplementer && !context.isTrialSubscription) {
          <ninety-navigation-menu-item
            data-cy="main-sidebar_refer-a-friend-item"
            data-product="main-sidebar__refer-a-friend-menu-button"
            #referAFriendTrigger
            type="button"
            iconKey="currency-dollar-circle"
            [title]="'Refer A Friend'"
            [isExpanded]="context.isExpanded"
            [showTooltip]="!isTablet"
            [theme]="context.currentTheme"
            tabindex="-1"
            [routerLink]="[{ outlets: { detail: null, primary: 'referral' } }]">
          </ninety-navigation-menu-item>
        }

        <hr class="user-menu-divider" />

        <ninety-navigation-menu-item
          data-product="main-sidebar__user-profile-button"
          data-cy="main-sidebar_user-profile-button"
          [isTall]="true"
          type="button"
          #userProfileTrigger
          [pictureURL]="avatar.pictureURL"
          [userInitials]="avatar.userInitials"
          [title]="avatar.fullUserName"
          [isExpanded]="context.isExpanded"
          [showTooltip]="!isTablet"
          [theme]="context.currentTheme"
          [secondaryIcon]="context.profileMenuIcon"
          [secondaryIconVariant]="context.profileMenuIcon === 'warning-circle' ? 'fill' : 'regular'"
          [secondaryIconClass]="context.profileMenuIcon === 'warning-circle' ? 'alert-red' : ''"
          (click)="showUserProfileMenu()">
        </ninety-navigation-menu-item>
      </mat-nav-list>
    }
  </div>
</section>
